import {UserModel} from '../user/user.model';

class UserResponse {}

namespace UserResponse {
  export class Login {
    token: string = undefined;
    user: UserModel = undefined;
  }

  export class Signup {
    user: UserModel = undefined;
  }

  export class FullProfile{
    user: UserModel.FullProfile = undefined;
  }

}

export {UserResponse};
